import classNames from 'clsx';
import { useEffect, useState, type PropsWithChildren } from 'react';

import type { IconProps } from 'components/Icon';

import styles from './FeedbackBar.module.css';

import { Icon } from 'components/Icon';
import { Repeater } from 'components/Repeater';

export type FeedbackBarProps = PropsWithChildren<{
  /** variant deciding color and icon, default success */
  variant?: 'information' | 'danger' | 'warning' | 'success';
  /** callback for on close that can optionally be used by parrent */
  onClose?: () => void;
}>;

/** Represents a component to show feedback within a Page. */
export const FeedbackBar = ({ children, variant = 'success', onClose }: FeedbackBarProps) => {
  const [isVisible, setIsVisible] = useState(false);

  function setIconName(feedbackVariant: typeof variant): IconProps['name'] {
    if (feedbackVariant === 'information') return 'SquareInfo';
    if (feedbackVariant === 'success') return 'CheckCircle';
    return 'ExclamationTriangleMini';
  }

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const close = () => {
    setIsVisible(false);
    onClose?.();
  };

  return (
    <div
      className={classNames(styles['feedback-bar'], styles[`feedback-bar--${variant}`], {
        [styles['feedback-bar--visible']]: isVisible,
      })}
      role="alert"
    >
      <Repeater flexDirection="row">
        <Icon name={setIconName(variant)} />
        {children}
      </Repeater>
      <button className={styles['feedback-bar__close-button']} type="button" onClick={close}>
        <Icon name="Cross" size={24} />
      </button>
    </div>
  );
};
